import { render } from "./AllCommissions.vue?vue&type=template&id=10e724d3&scoped=true"
import script from "./AllCommissions.vue?vue&type=script&lang=js"
export * from "./AllCommissions.vue?vue&type=script&lang=js"

import "./AllCommissions.vue?vue&type=style&index=0&id=10e724d3&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e724d3"]])

export default __exports__